import { DOMcreateElement } from '../typescript/TSXDomParse';
import LazyLoad from 'vanilla-lazyload';
import { notNullAndLengthy } from '../typescript/helpers';
var _document = document;
// Only load vanilla-lazyload once
if (!_document.lazyLoadInstance) {
    _document.lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy',
    });
}
/*
 * This function is responsible for rendering the list of global sponsors shown
 * at the bottom of the page, above the footer. Data is retrieved and provided by
 * the calling module, GlobalSponsors.ts
 */
export default function GlobalSponsorsElement(data) {
    var images = data.filter(function (link) { var _a, _b, _c, _d; return notNullAndLengthy((_d = (_c = (_b = (_a = link.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.file) === null || _d === void 0 ? void 0 : _d.url); });
    // Short-circuit when no images
    if (notNullAndLengthy(images) === false)
        return '';
    // Wait for images to be added to page before updating lazy load
    var imagesParent = document.querySelector('.footer-sponsors');
    var observer = new MutationObserver(function (mutationList, observer) {
        for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
            var mutation = mutationList_1[_i];
            mutation.addedNodes.forEach(function (el) {
                // For safety, check that the mutation includes our element
                // created at the end of GlobalSponsorsElement
                if ((el.id = 'global-sponsors')) {
                    // Update lazy load to watch for the newly added elements
                    console.log('UPDATE LAZY LOAD', el.querySelectorAll('[data-src]'), _document.lazyLoadInstance);
                    _document.lazyLoadInstance.update();
                    return observer.disconnect();
                }
            });
        }
    });
    observer.observe(imagesParent, { childList: true, subtree: true });
    return (DOMcreateElement("div", { id: "global-sponsors" }, images.map(function (link) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return (DOMcreateElement("a", { className: "image global-sponsor-image", href: (_a = link.fields) === null || _a === void 0 ? void 0 : _a.url, title: (_b = link.fields) === null || _b === void 0 ? void 0 : _b.title },
            DOMcreateElement("img", { className: "nav-image lazy", dataSrc: (_f = (_e = (_d = (_c = link.fields) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.fields) === null || _e === void 0 ? void 0 : _e.file) === null || _f === void 0 ? void 0 : _f.url, alt: (_k = (_j = (_h = (_g = link.fields) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.fields) === null || _j === void 0 ? void 0 : _j.file) === null || _k === void 0 ? void 0 : _k.title })));
    })));
}
